import React, { useEffect } from 'react'
import OptionAnalytic from '../Components/OptionAnalytic'

import { Box } from '@chakra-ui/react'
import TeamAnalytics from '../Components/TeamAnalytics'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AnalyticsFormFunc } from '../Redux/Form/Analytics'


const Analytics = () => {
  const Id = useParams()
  const userId = useSelector((state) => state.user.userData.userId);
  const dispatch=useDispatch()
  const Data=useSelector((state)=>state.AnalyticsSlice.Alldata?.data)
  console.log(Data,"Data")
  useEffect(()=>{
    dispatch(AnalyticsFormFunc(Id.formId,userId))
  },[Id.formId,userId])

  console.log(Data)
  return (
    <Box display={"flex"} flexDir={{base:"column",sm:"column",lg:"row"}} justifyContent={"space-between"} mt="20" >
        <Box>
        <OptionAnalytic data={Data} />
        </Box>
        <Box>
        <TeamAnalytics data={Data} />
        </Box>
    </Box>
  )
}

export default Analytics